// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Newg","title":"styles_title__RCE00"};